import type { FaireProductEntity } from "../../entity_types/product";

export const p_bjmyvaczc8: FaireProductEntity = {
  token: "p_bjmyvaczc8",
  type: "product",
  name: "2 pc Gorgeous Chrysocolla malachite free form H290",
  brandToken: "b_yrt8x5m6m6",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7404166d7356fc5249c198fa3404320d755c6cd573f2afa5be111cbc6b0687ab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a757a24d2b5e8ed3e6bb012aa50c4dbfe553b44c733010896504503a01e2f2b1.jpeg",
    "https://cdn.faire.com/fastly/dbc9b183e4cc550952ac3ca645ea7213c11cabbdf8246dcc9aa8b75f027c0b94.jpeg",
    "https://cdn.faire.com/fastly/f22fb07f6a06c28acc2c53f65674dc88e206b2d1ec7834c8419ae972005c4f3e.jpeg",
    "https://cdn.faire.com/fastly/0b902f72f633425764c11e5122fcbe60d0ac269b1ff5c92c5b91e56b1963cdea.jpeg",
    "https://cdn.faire.com/fastly/eb251071fa42e5e2eda6797aa78ce15d4f7a19fdfbc6d2ec09ab75148df876b3.jpeg",
    "https://cdn.faire.com/fastly/b54549c9e0b27bd5135643b80ec0f9a58afdcca3ec8a4f9992491d833707e5af.jpeg",
    "https://cdn.faire.com/fastly/22f05e2daaed023a5000110c31962907adae58e6d3318076f6e2d1e9a313b70c.jpeg",
  ],
  priceDollars: 108.09,
  description:
    "2 pc Gorgeous Chrysocolla malachite free form H290\n\nIt comes with one crystal info card\n\nThis is the exact set you will receive\n\nApprox 1 lb 1 oz \n",
  tags: [],
  msrpDollars: 216.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:16.994Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
